import React, { createContext, useRef, useState } from "react";
import {
  background,
  codeLang,
  getPresets,
  codeTheme,
  controls,
  shadow,
  type,
  family,
  size,
  lineHeight,
  allMenus,
  URLPermission,
  cardTheme,
  backgroundColor,
} from "../data/data";
import { handleMenu, closeMenu } from "../helper/menu";
import { handleCardTheme } from "../utils/update.utils";
export const Context = createContext(null);

export const ContextProvider = ({ children }) => {
  let [codeExport, setCodeExport] = useState({
    imageUrl: "",
    width: 0,
    height: 0,
    imageFile: null,
    url: "",
    isInstance: false,
  });
  let [show, setShow] = useState(true);
  let [code,setCode] = useState( `// program to find the ASCII value of a character

  // take input from the user
  const string = prompt('Enter a character: ');
  
  // convert into ASCII value
  const result = string.codePointAt(0);`);

  const codeRef = useRef(null);
  const resizeX = useRef(null);
  const resizeY = useRef(null);
  
  let [state, setState] = useState({
    fileName: "untitled",
    code,
    theme: {
      backgroundNoFill: false,
      backgroundColor,
      background,
      codeTheme,
      codeLang,
      cardTheme,
      presets: getPresets,
    },
    window: {
      controls,
      shadow,
    },
    editor: {
      font: {
        family,
        size,
        type,
      },
      lineHeight,
      lineNumber: true,
    },
    export: {
      URLPermission,
    },
  });

  /*** Handle Update*/

 const handleUpdate = (value, ss, tree) => {
  console.log(state, 'bug 1')
  let tempState = { ...state };
  let tempArr = tree.includes("font")
    ? tempState[tree[0]][tree[1]][tree[2]]
    : tempState[tree[0]][tree[1]];
  tempArr.forEach((val) => {
    val.selected = false;
  });
  tempArr = tempArr.filter((val) =>
    val.value === value ? (val.selected = true) : val
  );
  if (tree.includes("codeTheme")) {
    return handleCardTheme(tempState, state);
  } else {
    if (tree.includes("background")) {
      tempState.theme.backgroundNoFill = false;
    }
    return tempState;
  }
};
  const [menus, setMenus] = useState(allMenus);
  const [isOpen, setIsOpen] = useState(false);
  const value = {
    code,
    setCode,
    show,
    setShow,
    state,
    setState,
    menus,
    setMenus,
    handleMenu,
    isOpen,
    setIsOpen,
    closeMenu,
    codeRef,
    codeExport,
    setCodeExport,
    resizeX,
    resizeY,
    handleUpdate
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
